<template>
  <div class="row mb-4">
    <div class="col">
      <a :href="pdfUrl"
         class="btn btn-sm btn-primary">{{ trans('Download PDF') }}</a>
    </div>
  </div>
</template>

<script>
  import { apiClient } from '../api';

  export default {
    name: 'VehicleToolbar',

    props: {
      pdfUrl: {
        type: String,
        required: true,
      },
      markRoute: {
        type: String,
        required: true,
      },
      isStolenInitial: {
        type: Boolean,
        required: true,
      }
    },

    data() {
      return {
        loading: false,
        isStolen: this.isStolenInitial,
      }
    },

    methods: {
      toggleStolen() {
        if (this.loading) {
          return;
        }

        this.loading = true;

        apiClient
          .post(this.markRoute, { state: !this.isStolen })
          .then(response => {
            console.log(response.data);
          })
          .catch(error => {
          })
          .finally(() => {
            this.loading = false;
          })
      }
    }
  }
</script>
